






import { mapGetters } from "vuex";
import TicketsList from "./list/TicketsList.vue";

export default {
  name: "Tickets.vue",
  components: { TicketsList },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {},
};
